import React from 'react';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import svLocale from 'date-fns/locale/sv';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/fraunces/600.css';

import AppRouter from './AppRouter';
import Auth from '../Auth/Auth';
import CookieBanner from '../analytics/CookieBanner';
import Toast from '../Toast/Toast';
import UpgradePrompter from '../UpgradePrompter/UpgradePrompter';

import store from '../../redux';

import { createAppTheme } from '../../theme';

const theme = createAppTheme();

export default function App() {
    return (
        <React.StrictMode>
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={svLocale}>
                        <CssBaseline />
                        <Toast />
                        <UpgradePrompter />
                        <CookieBanner />
                        <Auth>
                            <AppRouter />
                        </Auth>
                    </LocalizationProvider>
                </ThemeProvider>
            </Provider>
        </React.StrictMode>
    );
}
